import * as state from '../core/state';
import * as dom from './dom';

export function displayMessage(messageContent: string, senderName?: string) {
    const messageElement = document.createElement('div');
    messageElement.classList.add('message');

    let displayPrefix = '';
    if (senderName) {
        displayPrefix = `[${senderName}] `;
    }

    messageElement.textContent = displayPrefix + messageContent;
    dom.messagesDiv.appendChild(messageElement);
    dom.messagesDiv.scrollTop = dom.messagesDiv.scrollHeight;
}

export function displayIncomeMessages() {
    dom.messagesDiv.innerHTML = '';
    state.incomeMessage.forEach(({ message, name }) => {
        displayMessage(message, name);
    });
}

export function renderConversationList() {
    dom.conversationList.innerHTML = '';

    state.conversations.forEach((conv, fingerprint) => {
        const conversationItem = document.createElement('div');
        conversationItem.classList.add('conversation-item');

        if (fingerprint === state.activeConversationPartner) {
            conversationItem.classList.add('active');
        }

        conversationItem.textContent = conv.name;
        conversationItem.dataset.fingerprint = fingerprint;

        conversationItem.addEventListener('click', () => {
            state.setActiveConversationPartner(fingerprint);
            renderConversationList();
        });
        dom.conversationList.appendChild(conversationItem);
    });
}
